<template>
  <div>
    <div class="toolbar-container">
      <div class="custom-button-group">
        <button
            v-for="(button, index) in buttons"
            :key="index"
            :class="['custom-button', { active: selectedButton === index }]"
            @click="selectButton(index)"
        >
          {{ button.label }}
        </button>
      </div>

      <div class="right-button-group">
        <el-button size="default" @click="refreshFiles" title="同步文件最新状态">
          刷新状态
        </el-button>
      </div>
    </div>

    <div
        class="component-container"
        v-loading="isLoading"
        element-loading-text="正在同步文件状态..."
        element-loading-background="rgba(255, 255, 255, 0.8)"
    >

      <keep-alive>
        <component :is="buttons[selectedButton].component"></component>
      </keep-alive>
    </div>

  </div>
</template>

<script>
import CommonFile from '@/components/params_parse/commonFileParse.vue';
import ImpedanceTable from '@/components/params_parse/impedance_table.vue';
import StructureTable from '@/components/params_parse/structure_table.vue';
import UnparseTable from '@/components/params_parse/unparse_table.vue';
import {refreshAllFile, refreshAllFileV2} from "@/components/file_process_js/main_process";

export default {
  components: {
    CommonFile,
    ImpedanceTable,
    StructureTable,
    UnparseTable
  },
  data() {
    return {
      isLoading: false,
      buttons: [
        {label: "文本资料", component: "CommonFile"},
        {label: "压合结构", component: "StructureTable"},
        {label: "阻抗数据", component: "ImpedanceTable"},
        {label: "未提取", component: "UnparseTable"},
        // {label: "丝印层", component: "SilkScreenLayer"},
        // {label: "其它层", component: "OtherLayer"},
      ],
      selectedButton: 0, // 默认选中第一个按钮
    };
  },
  methods: {
    async refreshFiles() {
      this.isLoading = true;
      try {
        await refreshAllFileV2();
      } catch (error) {
        console.error('refreshFiles method caught an error:', error);
      } finally {
        this.isLoading = false;
      }
    },

    // 处理按钮点击事件
    selectButton(index) {
      this.selectedButton = index;
    },
  },
};
</script>


<style scoped>

.component-container {
  min-height: 200px; /* 你可以根据实际内容调整这个值 */
  position: relative; /* v-loading 需要一个定位上下文 */
}

.toolbar-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* 按钮组容器 */
.custom-button-group {
  display: flex;
  position: relative;
  align-items: center;
  gap: 24px; /* 按钮间距 */
}

/* 自定义按钮样式 */
.custom-button {
  background-color: #ffffff;
  padding: 3px 7px;
  border: none; /* 去掉边框 */
  border-radius: 5px; /* 设置按钮圆角 */
  cursor: pointer;
  font-size: 14px;
  color: #333;
  transition: background-color 0.3s, color 0.3s;
}

.custom-button:hover {
  background-color: #e0e0e0;
}

/* 选中按钮样式 */
.custom-button.active {
  background-color: #409eff; /* 激活状态颜色 */
  color: #fff;
}

</style>
